import { get, post } from '../../api/api.service';

export interface BriteCustomerAddress {
  city: string;
  street: string;
  postal_code: string;
  country_id: string;
}

export interface BriteCallback {
  url: string;
  transaction_state?: string;
  session_state?: string;
}

export interface CreateBriteSessionRequest {
  countryId: string,
  brandName: string,
  locale: string,
  // redirectUri: string,
  // deeplinkRedirect: string,
  customerId?: string,
  customerFirstname: string,
  customerLastname: string,
  customerDob: string,
  customerEmail: string,
  customerAddress: {
    city: string,
    street: string,
    postalCode: string,
    countryId: string
  }
}

// Exact field names are unconfirmed against the backend yet — treat as open
// and adjust once verified (token field could be `token`/`client_token`/etc).
export interface CreateBriteSessionResponse {
  id: string;
  token: string;
  [key: string]: any;
}

export interface GetBriteSessionResponse {
  id: string;
  state?: string;
  [key: string]: any;
}

export const createBriteSessionApi = (
  payload: CreateBriteSessionRequest
): Promise<CreateBriteSessionResponse> =>
  post<CreateBriteSessionResponse>('/britebanksessionv2/sessions/bank-account-selection', payload);

export const getBriteSessionApi = (id: string): Promise<GetBriteSessionResponse> =>
  get(`/britebanksessionv2/sessions/${id}`,);
